/* @flow */

import { type EstimarPedidoVariables } from './types';
import { ESTIMATE_CREATE_ORDER } from './querys';
import loggiClient from './loggiClient';
import applyLoading from '../utils/apply-loading';

type Retorno = {
    data: {
        estimateCreateOrder: {
            totalEstimate: {
                totalCost: string,
                totalEta: number,
            }
        },
    },
};

const estimateCreateOrder = (variables: EstimarPedidoVariables): Promise<Retorno> => (
    loggiClient.query({ query: ESTIMATE_CREATE_ORDER, variables })
);

export default applyLoading(estimateCreateOrder);
